const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Question Builder Component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('videoQuestionBuilder', ['Application', 'AssessmentLib', '$translate', function (Application, AssessmentLib, $translate) {
  return {
    restrict: 'E',
    scope: {
      question: '=',
      companyLimits: '=',
      newAssessment: '=',
      save: '&'
    },
    template: require('../../../templates/directives/assessments/video-question-builder.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};
      self.limits = {
        max_attempts: 8,
        max_duration: 30
      };

      self.info = {
        setOption: function(type, value) {
          if (!$scope.question) {
            return null;
          }
          if (!$scope.question.question_options) {
            $scope.question.question_options = [];
          }
          for (var i = 0; i < $scope.question.question_options.length; i++) {
            if ($scope.question.question_options[i] && $scope.question.question_options[i].name === type) {
              $scope.question.question_options[i].value = value;
              return;
            }
          }
          $scope.question.question_options.push({name: type, value: value});
        },
        getOption: function(type) {
          if (!$scope.question) {
            return null;
          }
          if (!$scope.question.question_options) {
            $scope.question.question_options = [];
            return null;
          }
          for (var i = 0; i < $scope.question.question_options.length; i++) {
            if ($scope.question.question_options[i] && $scope.question.question_options[i].name === type) {
              return $scope.question.question_options[i].value;
            }
          }
        },
        currentVideoOption: 'web_cam_video',
        chooseAttempt: false,
        chooseAttemptChange: function() {
          if (self.info.getOption('choose_attempt') !== self.info.chooseAttempt) {
            self.info.chooseAttemptUpdate('choose_attempt');
          }
        },
        chooseAttemptUpdate: function() {
          self.info.setOption('choose_attempt', self.info.chooseAttempt);
        },
        allowUpload: false,
        allowUploadChange: function() {
          if (self.info.getOption('allow_upload') !== self.info.allowUpload) {
            self.info.allowUploadUpdate('allow_upload');
          }
        },
        allowUploadUpdate: function() {
          self.info.setOption('allow_upload', self.info.allowUpload);
        },
        manualPoints: 1,
        manualPointsChange: function(add) {
          if (add) {
            self.info.manualPoints++;
          }
          if (!add && self.info.manualPoints > 1) {
            self.info.manualPoints--;
          }
          self.info.manualPointsUpdate();
        },
        manualPointsUpdate: function() {
          if (self.info.manualPoints) {
            self.info.setOption('manual_points', self.info.manualPoints);
          }
        },
        maxAttempts: 1,
        maxAttemptsChange: function(add) {
          if (add && self.info.maxAttempts < self.limits.max_attempts) {
            self.info.maxAttempts++;
          }
          if (!add && self.info.maxAttempts > 1) {
            self.info.maxAttempts--;
          }
          self.info.maxAttemptsUpdate();
        },
        maxAttemptsUpdate: function() {
          if (self.info.maxAttempts) {
            self.info.setOption('max_attempts', self.info.maxAttempts);
          }
        },
        recordingLimit: 1,
        recordingLimitChange: function(add) {
          if (add && self.info.recordingLimit < self.limits.max_duration) {
            self.info.recordingLimit++;
          }
          if (!add && self.info.recordingLimit > 1) {
            self.info.recordingLimit--;
          }
          // self.info.recordingLimitUpdate();
        },
        recordingLimitUpdate: function() {
          if (self.info.recordingLimit) {
            self.info.setOption('recording_limit', self.info.recordingLimit);
          }
        },
        save: function() {
          if ($scope.newAssessment) {
            return;
          }
          if (!$scope.question.question) {
            // error for prompt
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.add_prompt']});
            return;
          }
          if (!self.info.getOption('recording_type')) {
            // error for recording type
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.video_set_type']});
            return;
          }
          if (!$scope.question.rubric_grading && !self.info.getOption('manual_points')) {
            // error for points for non rubric
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.video_points']});
            return;
          }
          if ($scope.question.rubric_grading) {
            if (!$scope.question.question_options || !$scope.question.question_options.length) {
              // error for points for non rubric
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.video_points']});
              return;
            }

            for (var i = 0; i < $scope.question.rubric_options.length; i++) {
              var item = $scope.question.rubric_options[i];
              if (!item) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.empty_rubric']});
                return;
              }
              if (!item.name || !item.points || !item.description) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.rubric_requirements']});
                return;
              }
            }
          }
          $scope.save();
        },
        web_cam_video: false,
        screen_voice: false,
        screen_no_voice: false,
        changeRecordingType: function(type) {
          self.info.setOption('recording_type', type);
          self.info.web_cam_video = type === 'web_cam_video' ? true : false;
          self.info.screen_voice = type === 'screen_voice' ? true : false;
          self.info.screen_no_voice = type === 'screen_no_voice' ? true : false;
        },
        totalPoints: function() {
          return AssessmentLib.helpers.getQuestionValue($scope.question);
        }
      };

      $scope.$watch('videoBuilder.info.recordingLimit', function(newVal, oldVal) {
        if (newVal || newVal === 0) {
          if (newVal < 1) {
            self.info.recordingLimit = 1;
            self.info.recordingLimitUpdate();
            return;
          }
          if (newVal > self.limits.max_duration && $scope.newAssessment) {
            self.info.recordingLimit = self.limits.max_duration;
            self.info.recordingLimitUpdate();
            return;
          }
          self.info.recordingLimitUpdate();
        }
      });

      $translate([
        'edit.assessment.add_prompt',
        'edit.assessment.video_set_type',
        'edit.assessment.video_points',
        'edit.assessment.empty_rubric',
        'edit.assessment.rubric_requirements'
      ]).then(function(translations) {
        self.translations = translations;
      });


      if ($scope.question) {
        self.info.manualPoints = self.info.getOption('manual_points') || 1;
        self.info.maxAttempts = self.info.getOption('max_attempts') || 1;
        self.info.recordingLimit = self.info.getOption('recording_limit') || 1;
        self.info.chooseAttempt = self.info.getOption('choose_attempt') || false;
        self.info.allowUpload = self.info.getOption('allow_upload') || false;
        var initialRecordingType = self.info.getOption('recording_type');
        self.info.changeRecordingType(initialRecordingType || 'web_cam_video');
        if ($scope.companyLimits) {
          self.limits.max_duration = $scope.companyLimits.max_duration || self.limits.max_duration;
          self.limits.max_attempts = $scope.companyLimits.max_attempts || self.limits.max_attempts;
        }
        if (self.info.maxAttempts > self.limits.max_attempts) {
          self.limits.max_attempts = self.info.maxAttempts;
        }
        return;
      }



      var questionWatch = $scope.$watch('question', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.info.manual_points = self.info.getOption('manual_points') || 1;
          self.info.maxAttempts = self.info.getOption('max_attempts') || 1;
          self.info.recordingLimit = self.info.getOption('recording_limit') || 1;
          self.info.chooseAttempt = self.info.getOption('choose_attempt') || false;
          self.info.allowUpload = self.info.getOption('allow_upload') || false;
          var initialRecordingType = self.info.getOption('recording_type');
          self.info.changeRecordingType(initialRecordingType || 'web_cam_video');
          questionWatch();
        }
      });

    }],
    controllerAs: 'videoBuilder'
  };
}]);